import React, { Component } from "react";
import { Helmet } from "react-helmet";

class SEO extends Component {
  render() {
    // We define the content inside the render method
    const title = "AJG Software | Software Consulting and Development, Cheshire";
    const description = "Specialist software consultancy in Cheshire, England. Expert design and development for Industrial Automation, AI, IoT, and Robotics.";
    const image = "/logo-preview.png"; // Optional: path to a preview image for social media

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="image" content={image} />
        
        {/* These 'og' tags help your site look professional when shared on LinkedIn */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
      </Helmet>
    );
  }
}

export default SEO;